var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AuditItemDetails',{attrs:{"item":_vm.transformedItem,"ignored-rows":['metadata', 'criteria', 'data'],"messages":_vm.transformedMessages}})
}
var staticRenderFns = []

export { render, staticRenderFns }